import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import { cardImage, profile } from "../../assests";
import {
  Container,
  InfoItem,
  Modal,
  Heading,
  Grid,
  Card,
  GoBackBtn,
  FormText,
  Button,
} from "../../components";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { Puff } from "react-loader-spinner";
import {
  GetSingleVendor,
  DeleteSingleVendor,
  clearErrors,
  clearMessages,
  GetVendorAllService,
  getAllChats,
} from "./../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import { getChatOfAvailableChats } from "../../utils/getChat";
import { formatDate, getLoggedInUserDetails } from "../../utils";
import { BACKEND_STATIC_URL } from "../../constants";
import styled from "@emotion/styled";
import * as Yup from "yup";
import { Form, Formik } from "formik";

const VenderDetail = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [alert, setAlert] = useState(false);
  const dispatch = useDispatch();
  const { data, errors, message, loading, vendorServices } = useSelector(
    (state) => state.adminReducer
  );

  useEffect(() => {
    if (errors.length > 0) {
      toast.error(errors);
      dispatch(clearErrors());
    }
    if (message != "") {
      toast.success(message);
      dispatch(clearMessages());
      setTimeout(() => navigate("/vender"), 2000);
    }
  }, [errors, message, navigate, dispatch]);

  useEffect(() => {
    dispatch(GetSingleVendor(id));
    dispatch(GetVendorAllService(id));
  }, [id, dispatch]);

  useEffect(() => {
    dispatch(getAllChats());
  }, [dispatch]);

  const deletionValidation = Yup.object({
    reason: Yup.string()
      .min(2, "Must be 2 character")
      .max(250, "Must be 250 characters or less")
      .required("Required"),
  });
  return (
    <>
      {alert ? (
        <Modal onClose={() => setAlert((p) => !p)}>
          <div className="px-3">
            <Heading className="normal center m-4">Delete Account</Heading>
            <div>
              <Formik
                initialValues={{
                  reason: "",
                }}
                validateOnMount
                validationSchema={deletionValidation}
                onSubmit={(values, { resetForm }) => {
                  dispatch(DeleteSingleVendor(id, values.reason));
                  setAlert(false);
                }}
              >
                {(formik) => (
                  <Form>
                    <FormText
                      label="Provide a reason for acceptance"
                      name="reason"
                      type="text"
                      cols="100"
                      rows="10"
                    />
                    <Button className="btn-lighter rounded center m-2">
                      Submit
                    </Button>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </Modal>
      ) : (
        ""
      )}

      <Container className="lg">
        <GoBackBtn className="m-4" />
      </Container>
      <Container className="md">
        <Heading className="primary center m-6">Vendor Detail</Heading>
        {loading ? (
          <Puff
            height="60"
            width="60"
            radius="6"
            color="black"
            ariaLabel="loading"
            wrapperStyle
            wrapperClass
          />
        ) : data.length > 0 ? (
          data.map((item, ind) => {
            return (
              <div className="customerdetailpage m-5" key={ind}>
                <div className="customerdetailpage-container m-5">
                  <Container className="lg">
                    <div className="customerdetailpage-container-top">
                      <div className="customerdetailpage-container-top-profile">
                        <img
                          src={
                            item?.photoPath
                              ? `${BACKEND_STATIC_URL}${item?.photoPath}`
                              : profile
                          }
                          alt="profile"
                        />
                        <h4>{item.fullName}</h4>
                      </div>
                      <div className="customerdetailpage-container-top-button">
                        <Link
                          to={`/chat/vendor?chatId=${
                            getChatOfAvailableChats(
                              getLoggedInUserDetails().user?.id,
                              item.id
                            )?._id
                          }`}
                        >
                          Message
                        </Link>
                        <button
                          onClick={() => {
                            setAlert(!alert);
                          }}
                        >
                          Delete Account
                        </button>
                      </div>
                    </div>
                  </Container>
                  <div className="customerdetailpage-container-content m-5">
                    <Container className="lg">
                      <InfoItem
                        title="Email"
                        content={item.email ? item.email : ""}
                      />
                      <InfoItem
                        title="Phone number"
                        content={item.phone ? item.phone : ""}
                      />
                      <InfoItem
                        title="Date of join"
                        content={
                          item.createdAt ? formatDate(item.createdAt) : ""
                        }
                      />
                      <InfoItem
                        title="Instagram"
                        content={
                          <a
                            href={
                              item?.instagram?.includes("http")
                                ? item?.instagram
                                : `https://www.instagram.com/${item?.instagram}`
                            }
                            style={{ color: "blue" }}
                            target="_blank"
                            rel="noreferrer"
                          >
                            {item?.instagram?.includes("http")
                              ? item?.instagram
                              : `https://www.instagram.com/${item?.instagram}`}
                          </a>
                        }
                      />
                    </Container>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <h1>No record found</h1>
        )}

        {/* Services Section  */}

        <div className="m-6">
          <Heading className="center m-4 primary">Services</Heading>
          <div className="m-6">
            {vendorServices.length === 0 ? (
              <p>No Service Found!</p>
            ) : (
              <LayoutStyled>
                {vendorServices?.map((s, i) => (
                  <Card
                    key={i}
                    image={
                      s?.thumbnails && s?.thumbnails[0]
                        ? `${BACKEND_STATIC_URL}${s?.thumbnails[0]}`
                        : cardImage
                    }
                    name={
                      s?.customServiceName ||
                      s?.serviceName?.serviceName ||
                      "--"
                    }
                    description={s?.description || "No description available."}
                    views="25k"
                    to={`/service_detail/${s?.id}`}
                  />
                ))}
              </LayoutStyled>
            )}
            <br />
            <br />
            <br />
            <br />
          </div>
        </div>
      </Container>
    </>
  );
};

export default VenderDetail;

export const LayoutStyled = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(28rem, 1fr));
`;
